<template>
  <div class="page-wrap">
    <div class="wraper">
      <div class="earth-area">
        <div class="earth-img">
          <img :src="img1" alt />
          <img :src="img2" class="top-img" alt />
          <div class="mark first-mark">
            <span class="mark-point first-point"></span>
            <div class="mark-label">
              <span class="large-label">{{ countInvestor }}多万</span>期货投资者
            </div>
          </div>
          <div class="mark second-mark">
            <span class="mark-point second-point"></span>
            <div class="mark-label">
              <span class="large-label">{{ countInvestment }}</span>家投资机构
            </div>
          </div>
          <div class="mark third-mark">
            <span class="mark-point third-point"></span>
            <div class="mark-label">
              <span class="large-label">{{countSecurity}}</span>家证券公司
            </div>
          </div>
          <div class="mark fourth-mark">
            <span class="mark-point fourth-point"></span>
            <div class="mark-label">
              <span class="large-label">{{countFutures}}</span>家期货公司
            </div>
          </div>
        </div>
      </div>
      <div class="content-wrap">
        <div class="license-area">
          <div class="license">
            <div class="license-content">
              <img class="t-img" src="../../assets/img/mss.png" alt />
              <div class="license-name">
                中国期货软
                <br />件行业领军
                <br />企业奖
              </div>
            </div>
            <div class="organization">（中国软件行业协会颁发）</div>
          </div>
          <div class="license">
            <div class="license-content">
              <img class="t-img" src="../../assets/img/mss.png" alt />
              <div class="license-name">
                中国金软件期
                <br />货行业最具影
                <br />响力企业
              </div>
            </div>
            <div class="organization">（由中国电子信息产业发展研究院颁发）</div>
          </div>
          <div class="license">
            <div class="license-content">
              <img class="t-img" src="../../assets/img/mss.png" alt />
              <div class="license-name">
                中国金服务
                <br />期货行业最
                <br />具影响力服
                <br />务商
              </div>
            </div>
            <div class="organization">（由中国电子信息产业发展研究院颁发）</div>
          </div>
        </div>
        <div class="introduce-area">
          <div class="module-label">公司介绍</div>
          <div class="company-img">
            <img class="t-img" :src="img3" />
          </div>
          <div class="introduce-content">
            <p v-for="(item, index) in introduceInfo" :key="index">{{item}}</p>
            <div class="link-web">
              <span>&gt;&gt;&gt;</span>
              <a target="-blank" href="https://www.wenhua.com.cn">到文华财经官网了解更多内容</a>
            </div>
          </div>
        </div>
      </div>
    </div>
   <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img1: `${process.env.BASE_URL}ImgFiles/top-gsfz_02.jpg`,
      img2: `${process.env.BASE_URL}ImgFiles/top-gsfz_03.png`,
      img3: `${process.env.BASE_URL}ImgFiles/qiantai.jpg`,
    };
  },
  computed: {
    establishTime() {
      return this.$store.state.commonData.establishTime;
    },
    countSecurity() {
      return this.$store.state.commonData.countSecurity;
    },  // 证券公司数量
    countInvestment() {
      return this.$store.state.commonData.countInvestment;
    },  // 投资机构数量
    countInvestor() {
      return this.$store.state.commonData.countInvestor;
    },  // 期货投资者数量（万）
    countFutures() {
      return this.$store.state.commonData.countFutures;
    },  // 期货公司数量
    introduceInfo() {
      return [
        `文华财经创立于${this.establishTime}年，是中国程序化交易的开创者。`,
        `文华财经是一家金融科技公司，行业软件开发独角兽企业，我们的业务涉及股票、期货、外汇、期权等金融投资领域，产品已经打入${this.countSecurity}家证券公司、${this.countFutures}家期货公司和${this.countInvestment}家投资机构，日均百万级终端用户，市场覆盖率超过90%。`,
        `技术方面，文华一直追求技术领先。早在2012年文华就在产品中有效的运用了云计算、大数据等新技术，近两年业务深入股票和其他投资市场，现在基于大数据、人工智能技术的程序化交易系列软件成为我们的又一个核心业务。`,
        `人才方面，文华秉持“用一流待遇吸纳一流人才”的理念，打造了“一线城市起薪水平、每季度涨薪评定、年年持续增长”的薪酬体系，以及“免除员工后顾之忧、惠及员工父母家人”的福利体系，为人才打造一个终身成长、终身发展的平台。`,
        `一流的企业渴求一流的人才，我们对优秀的人才提供无限发展的可能，如果您自信无畏、不惧考验，诚挚欢迎加入文华财经！`,
      ]
    },
  },
};
</script>

<style scoped>
.page-wrap {
  
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.content-wrap {
  padding: 1.4393rem 0.3386rem;
}
.earth-area {
  width: 100%;
}
.earth-img {
  width: 100%;
  position: relative;
}
.earth-img img {
  width: 100%;
}
.top-img {
  width: 100%;
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
}
.earth-area .mark {
  position: absolute;
  height: 0.8rem;
  line-height: 0.8rem;
}
.earth-area .mark-point {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  display: inline-block;
  position: absolute;
  margin-top: 0.2rem;
  margin-left: 0.2rem;
}
@keyframes actionpoint1 {
  0% {
    box-shadow: none;
  }
  50% {
    box-shadow: 0 0 0px 0.2rem rgba(255, 195, 81, 0.25);
  }
  100% {
    box-shadow: none;
  }
}
@keyframes actionpoint2 {
  0% {
    box-shadow: none;
  }
  50% {
    box-shadow: 0 0 0px 0.2rem rgba(80, 180, 255, 0.25);
  }
  100% {
    box-shadow: none;
  }
}
@keyframes actionpoint3 {
  0% {
    box-shadow: none;
  }
  50% {
    box-shadow: 0 0 0px 0.2rem rgba(12, 197, 184, 0.25);
  }
  100% {
    box-shadow: none;
  }
}
@keyframes actionpoint4 {
  0% {
    box-shadow: none;
  }
  50% {
    box-shadow: 0 0 0px 0.2rem rgba(251, 132, 71, 0.25);
  }
  100% {
    box-shadow: none;
  }
}
.first-mark {
  top: 30%;
  left: 22%;
}
.second-mark {
  top: 63%;
  left: 4%;
}
.third-mark {
  top: 40%;
  right: 4%;
}
.fourth-mark {
  top: 55%;
  right: 16%;
}
.first-point {
  background: rgb(255, 195, 81);
  box-shadow: 0 0 0px 0.2rem rgba(255, 195, 81, 0.25);
  animation: actionpoint1 1s infinite;
  -webkit-animation: actionpoint1 1s infinite;
}
.second-point {
  background: rgb(80, 180, 255);
  box-shadow: 0 0 0px 0.2rem rgba(80, 180, 255, 0.25);
  animation: actionpoint2 1s infinite;
  -webkit-animation: actionpoint2 1s infinite;
}
.third-point {
  background: rgb(12, 197, 184);
  box-shadow: 0 0 0px 0.2rem rgba(12, 197, 184, 0.25);
  animation: actionpoint3 1s infinite;
  -webkit-animation: actionpoint3 1s infinite;
}
.fourth-point {
  background: rgb(251, 132, 71);
  box-shadow: 0 0 0px 0.2rem rgba(251, 132, 71, 0.25);
  animation: actionpoint4 1s infinite;
  -webkit-animation: actionpoint4 1s infinite;
}
.earth-area .mark-label {
  display: inline-block;
  font-size: 0.5rem;
  font-family: "SimSun";
  font-weight: bold;
  color: #26609b;
  margin-left: 0.8rem;
}
.earth-area .large-label {
  font-size: 0.8rem;
}
.license-area {
  width: 100%;
  margin-bottom: 0.6773rem;
  display: table;
}
.license-area .license {
  text-align: center;
  display: table-cell;
  vertical-align: top;
}
.license-area .license:first-child,
.license-area .license:last-child {
  width: 33.33%;
}
.license-area .license-content {
  width: 90%;
  margin: 0 auto;
  position: relative;
}
.license-area .license-name {
  width: 100%;
  font-size: 0.508rem;
  font-weight: bold;
  color: #824e15;
  position: absolute;
  top: 50%;
  left: 50%;
  letter-spacing: 0px;
  transform: translate(-50%, -50%);
  -webkit-transform: translateY(-50%, -50%);
}
.license-area .organization {
  font-size: 0.508rem;
  color: #aeaeae;
  margin-top: 0.2116rem;
  width: 100%;
  text-align: center;
}
.introduce-area .introduce-content {
  font-size: 0.58rem;
  color: #676767;
  text-align: justify;
}
.introduce-area .introduce-content p {
  line-height: 1rem;
}
.introduce-area .company-img {
  /* width: 80%; */
  margin: 0 auto;
}
.introduce-area .link-web {
  color: #16299a;
}
.introduce-area .link-web a {
  text-decoration: underline;
}
.introduce-area .link-web a:link,
a:visited {
  color: #16299a;
}
</style>